module.exports = __webpack_public_path__ + "static/media/8OLA30.0b705219.jpg";